<div *ngIf="isVisible" class="rs-entrypoint-container">
  <a
    (click)="onClick()"
    class="rs-entrypoint"
    [class.rs-entrypoint-disabled]="isDisabled"
    [attr.aria-disabled]="isDisabled ? 'true' : null"
    data-tms-event="button-click"
    data-tms-button-zone="mybill.options.deferral.card"
    data-tms-button-name="delay payment"
    [attr.data-tms-message-info]="billingAccountNumber"
    [attr.data-tms-context]="documentReference"
  >
    <i class="icon-Calendar icon-lh rs-entrypoint-icon" aria-hidden="true"></i>
    <span class="rs-entrypoint-title">{{ title }}</span>
    <span class="rs-entrypoints-txt">{{ text }}</span>
    <span class="rs-entrypoint-arrow" aria-hidden="true"></span>
  </a>
</div>
<my-bill-modal-login-required
  [showModal]="showModal"
  [redirectToLoginLink]="redirectLink"
  *ngIf="showModal"
  (hideModal)="onCancel()"
>
</my-bill-modal-login-required>
